import React from 'react'
import { Redirect } from 'react-router-dom'

import { routes } from '@sketch/modules-common'

import { useVersioning } from '../../../versioning'
import { useUnfollowShareFromEmail } from '../../operations'

/**
 * Unsubscribes from a share's notifications, then takes the URL back to the
 * share.
 *
 * Mounted as a sibling of whatever view the URL names, so the share still
 * loads and renders while this happens. It lives in the router rather than
 * inside a view so that changing the view cannot quietly break unsubscribing.
 */
export const UnsubscribeShareNotifications = () => {
  const { versionShortId, share } = useVersioning()

  useUnfollowShareFromEmail({
    versionShortId,
    shareIdentifier: share.identifier,
    shareName: share.name,
    subscriptionStatus: share.subscriptionStatus,
  })

  return (
    <Redirect to={routes.SHARE_VIEW.create({ shareID: share.identifier })} />
  )
}
